import * as React from 'react';
import { GlobalStyles } from '@xingternal/tokens';
import { useFrameHooks, useFrameContext } from '@xingternal/hub';
import { selectCookieDataByName } from './cookie-parsing';
const themes = ['dark', 'light', 'system'];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isTheme = (value) => {
    return themes.includes(value);
};
const getCookieValue = () => {
    const value = typeof document !== 'undefined' &&
        selectCookieDataByName(document.cookie, 'activeTheme');
    return isTheme(value) ? value : 'system';
};
const setCookieValue = (activeTheme) => {
    document.cookie = `activeTheme=${activeTheme};path=/`;
};
const setThemeClass = (activeTheme) => {
    themes.forEach((theme) => {
        document.documentElement.classList.toggle(theme, theme === activeTheme);
    });
};
const ThemingProvider = ({ children, }) => {
    React.useEffect(() => {
        setThemeClass(getCookieValue());
    }, []);
    const { useFeatureSwitches } = useFrameHooks();
    const { featureSwitches, loading } = useFeatureSwitches
        ? // eslint-disable-next-line react-hooks/rules-of-hooks
            useFeatureSwitches()
        : { featureSwitches: [], loading: false };
    const forceLightTheme = !loading && !(featureSwitches === null || featureSwitches === void 0 ? void 0 : featureSwitches.includes('enable_dark_mode_web'));
    React.useEffect(() => {
        if (forceLightTheme) {
            setThemeClass('light');
        }
    }, [forceLightTheme]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyles, null),
        children));
};
const enhanceElement = (children) => {
    return React.createElement(ThemingProvider, null, children);
};
const useTheme = () => {
    const theme = getCookieValue();
    const { moduleState } = useFrameContext();
    const [, setHubState] = moduleState;
    const setTheme = (currentTheme) => {
        setCookieValue(currentTheme);
        setThemeClass(currentTheme);
        setHubState((hubState) => ({ ...hubState }));
    };
    return [theme, setTheme];
};
const getIsDarkMode = () => typeof window !== 'undefined' &&
    window.matchMedia('(prefers-color-scheme: dark)').matches;
const useIsDarkMode = () => {
    const [theme] = useTheme();
    const [isPreferedDark, setIsPreferedDark] = React.useState(getIsDarkMode);
    const isThemeSystem = theme === 'system';
    React.useEffect(() => {
        if (!isThemeSystem)
            return;
        const mqListener = (e) => {
            setIsPreferedDark(e.matches);
        };
        const darkThemeMq = window.matchMedia('(prefers-color-scheme: dark)');
        darkThemeMq.addEventListener('change', mqListener);
        return () => darkThemeMq.removeEventListener('change', mqListener);
    }, [isThemeSystem]);
    return isThemeSystem ? isPreferedDark : theme === 'dark';
};
const getHooks = () => {
    return { useTheme, useIsDarkMode };
};
export const themingModule = {
    name: 'themingModule',
    getHooks,
    enhanceElement,
};
//# sourceMappingURL=theming.js.map